module.exports = __webpack_public_path__ + "static/media/mail-fill.c65d6e04.svg";